import React from "react";
import { Link } from "react-router-dom";
import {FiCheckCircle} from '../assets/icons/vander'

export default function Pricing(){
    return(
        <>
            <div className="grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 mt-6 gap-6">
                {/* Test Drive Card */}
                <div className="relative overflow-hidden rounded-md shadow dark:shadow-gray-800">
                    <div className="p-6">
                        <h5 className="text-2xl leading-normal font-semibold">Test Drive</h5>
                        <p className="text-slate-400 mt-2">Experience the power of secure AI</p>
                        <div className="flex mt-4">
                            <span className="text-5xl font-semibold mb-0">Free</span>
                        </div>
                        <p className="text-slate-400 uppercase text-sm mt-2">15-day trial</p>

                        <div className="mt-6">
                            <Link to="/contact" className="py-2 px-5 inline-block font-semibold tracking-wide border align-middle duration-500 text-base text-center bg-amber-400/5 hover:bg-amber-400 border-amber-400/10 hover:border-amber-400 text-amber-400 hover:text-white rounded">Start Free Trial</Link>
                            <p className="text-slate-400 text-sm mt-3">No credit card required</p>
                        </div>
                    </div>

                    <div className="p-6 bg-gray-50 dark:bg-slate-800">
                        <ul className="list-none text-slate-400">
                            <li className="font-semibold text-slate-900 dark:text-white text-sm uppercase">Features:</li>
                            <li className="flex items-center mt-2"><FiCheckCircle className="text-amber-400 h-[18px] w-[18px] me-2"/> <span className="text-slate-900 dark:text-white me-1 font-semibold">1GB</span> Data Processing</li>
                            <li className="flex items-center mt-2"><FiCheckCircle className="text-amber-400 h-[18px] w-[18px] me-2"/> Document Intelligence System</li>
                            <li className="flex items-center mt-2"><FiCheckCircle className="text-amber-400 h-[18px] w-[18px] me-2"/> Natural Language to SQL</li>
                            <li className="flex items-center mt-2"><FiCheckCircle className="text-amber-400 h-[18px] w-[18px] me-2"/> Basic Support</li>
                            <li className="flex items-center mt-2"><FiCheckCircle className="text-amber-400 h-[18px] w-[18px] me-2"/> Core Security Features</li>
                        </ul>
                    </div>
                </div>

                {/* Managed Solution Card */}
                <div className="relative overflow-hidden rounded-md shadow dark:shadow-gray-800">
                    <div className="p-6">
                        <h5 className="text-2xl leading-normal font-semibold">Managed Solution</h5>
                        <p className="text-slate-400 mt-2">Perfect for modern teams</p>
                        
                        <div className="mt-4">
                            <p className="text-lg text-slate-400">Custom Pricing</p>
                            <p className="text-slate-400 mt-2">Tailored to your needs</p>
                        </div>

                        <div className="mt-6">
                            <Link to="/contact" className="py-2 px-5 inline-block font-semibold tracking-wide border align-middle duration-500 text-base text-center bg-amber-400 hover:bg-amber-500 border-amber-400 hover:border-amber-500 text-white rounded">Contact Sales</Link>
                        </div>
                    </div>

                    <div className="p-6 bg-gray-50 dark:bg-slate-800">
                        <ul className="list-none text-slate-400">
                            <li className="font-semibold text-slate-900 dark:text-white text-sm uppercase">Features:</li>
                            <li className="flex items-center mt-2"><FiCheckCircle className="text-amber-400 h-[18px] w-[18px] me-2"/> Managed Cloud Infrastructure</li>
                            <li className="flex items-center mt-2"><FiCheckCircle className="text-amber-400 h-[18px] w-[18px] me-2"/> Automatic Scaling</li>
                            <li className="flex items-center mt-2"><FiCheckCircle className="text-amber-400 h-[18px] w-[18px] me-2"/> 24/7 Monitoring</li>
                            <li className="flex items-center mt-2"><FiCheckCircle className="text-amber-400 h-[18px] w-[18px] me-2"/> Priority Support</li>
                            <li className="flex items-center mt-2"><FiCheckCircle className="text-amber-400 h-[18px] w-[18px] me-2"/> Regular Updates & Maintenance</li>
                        </ul>
                    </div>
                </div>

                {/* Enterprise Suite Card */}
                <div className="relative overflow-hidden rounded-md shadow dark:shadow-gray-800">
                    <div className="p-6">
                        <h5 className="text-2xl leading-normal font-semibold">Enterprise Suite</h5>
                        <p className="text-slate-400 mt-2">Maximum control and security</p>

                        <div className="mt-4">
                            <div className="flex items-center">
                                <span className="text-lg font-semibold">$</span>
                                <span className="text-5xl font-semibold mb-0 ms-1">14,500</span>
                            </div>
                            <p className="text-slate-400 text-sm mt-1">/TB/year or $1,250/TB/month</p>
                            <div className="mt-2">
                                <span className="bg-amber-400/10 text-amber-400 text-xs px-2 py-1 rounded">15% off first year</span>
                            </div>
                        </div>

                        <div className="mt-6">
                            <Link to="/contact" className="py-2 px-5 inline-block font-semibold tracking-wide border align-middle duration-500 text-base text-center bg-amber-400 hover:bg-amber-500 border-amber-400 hover:border-amber-500 text-white rounded">Get Started</Link>
                            <p className="text-slate-400 text-sm mt-3">Includes 3 months free</p>
                        </div>
                    </div>

                    <div className="p-6 bg-gray-50 dark:bg-slate-800">
                        <ul className="list-none text-slate-400">
                            <li className="font-semibold text-slate-900 dark:text-white text-sm uppercase">Features:</li>
                            <li className="flex items-center mt-2"><FiCheckCircle className="text-amber-400 h-[18px] w-[18px] me-2"/> Custom Data Volume</li>
                            <li className="flex items-center mt-2"><FiCheckCircle className="text-amber-400 h-[18px] w-[18px] me-2"/> Full RAG Capabilities</li>
                            <li className="flex items-center mt-2"><FiCheckCircle className="text-amber-400 h-[18px] w-[18px] me-2"/> Enterprise Security</li>
                            <li className="flex items-center mt-2"><FiCheckCircle className="text-amber-400 h-[18px] w-[18px] me-2"/> 24/7 Priority Support</li>
                            <li className="flex items-center mt-2"><FiCheckCircle className="text-amber-400 h-[18px] w-[18px] me-2"/> Voice Support (+$2,000/year)</li>
                        </ul>
                    </div>
                </div>
            </div>
        </>
    )
}